<template>
  <div :class="[$style.container, 'columns is-mobile']">
    <div class="column is-half-tablet is-full-mobile">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div
            :class="$style.image"
            :style="{
              backgroundImage:
                'url(https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/pressuregauges_en_co_rs_w180_h97_image.jpg)',
            }"
          >
            <img
              src="https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/pressuregauges_en_co_rs_w180_h97_image.jpg"
            />
          </div>
          <figcaption>
            <h3>Manometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half-tablet is-full-mobile">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div
            :class="$style.image"
            :style="{
              backgroundImage:
                'url(https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/pressuresensors_en_co_rs_w180_h97_image.jpg)',
            }"
          >
            <img
              src="https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/pressuresensors_en_co_rs_w180_h97_image.jpg"
            />
          </div>
          <figcaption>
            <h3>Drucksensoren</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half-tablet is-full-mobile">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div
            :class="$style.image"
            :style="{
              backgroundImage:
                'url(https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/pressureswitches_en_co_rs_w180_h97_image.jpg)',
            }"
          >
            <img
              src="https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/pressureswitches_en_co_rs_w180_h97_image.jpg"
            />
          </div>
          <figcaption>
            <h3>Digitalmanometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half-tablet is-full-mobile">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div
            :class="$style.image"
            :style="{
              backgroundImage:
                'url(https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/resistancethermometers_en_co_rs_w180_h97_image.jpg)',
            }"
          >
            <img
              src="https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/resistancethermometers_en_co_rs_w180_h97_image.jpg"
            />
          </div>
          <figcaption>
            <h3>Zeigerthermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half-tablet is-full-mobile">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div
            :class="$style.image"
            :style="{
              backgroundImage:
                'url(https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/digitalpressuregauges_en_co_rs_w180_h97_image.jpg)',
            }"
          >
            <img
              src="https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/digitalpressuregauges_en_co_rs_w180_h97_image.jpg"
            />
          </div>
          <figcaption>
            <h3>Rindfleischetikettierungsüberwachungsaufgabenübertragungsgesetz</h3>
          </figcaption>
        </figure>
      </a>
    </div>
    <div class="column is-half-tablet is-full-mobile">
      <a :class="$style.bigNavButton" href="#" target="_self">
        <figure>
          <div
            :class="$style.image"
            :style="{
              backgroundImage:
                'url(https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/hvac_en_co_rs_w180_h97_image.jpg)',
            }"
          >
            <img
              src="https://wika-www.qa.etecture.de/media/Images/ShopHome_180x97/hvac_en_co_rs_w180_h97_image.jpg"
            />
          </div>
          <figcaption>
            <h3>Zeiger-<br />thermometer</h3>
          </figcaption>
        </figure>
      </a>
    </div>
  </div>
</template>

<script setup></script>

<style module lang="scss">
@forward './BigNavButtons.scss';
</style>
